export default "__VITE_ASSET__BeYCMXhO__"